import React, { useEffect, useState, useRef } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import InfiniteScroll from 'components/InfiniteScroll';
import Fab from 'components/Fab';
import InfoMessage from 'components/InfoMessage';
import Input from 'components/Input';
import Button from 'components/Button';
import Sidebar from 'components/Sidebar';
import Snackbar from 'components/Snackbar';

import CardModels from './Card.js';
import api from '../../../services/apis/cooperplace';

export default function ModelsManufacturersList(props) {
  const toogleRef = useRef(null);
  const scrollRef = useRef(null);

  const [name, setName] = useState('');
  const [id, setId] = useState('');
  const [manufacturer, setManufacturer] = useState();
  const [snackBar, setSnackBar] = useState({
    display: false,
    type: 'info',
    message: '',
  });

  useEffect(() => {
    async function fetchManufacturer() {
      const endpoint = `vehicles/manufacturers/${props.match.params.id}`;

      try {
        const response = await api.get(endpoint);
        setManufacturer(response.data?.name);
      } catch (error) {
        showErrorMessage('Erro ao carregar fabricante');
      }
    }

    fetchManufacturer();
  }, [props.match.params.id]);

  function handleOpened(model) {
    setName(model.name);
    setId(model.id);

    toogleRef.current.toggle();
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!id) {
        const response = await api.post(`vehicles/manufacturers/${props.match.params.id}/models`, {
          name,
        });

        if (response.status === 200) {
          if (response.data.error) {
            showErrorMessage(response.data.error);
          } else {
            showSuccessMessage(`Modelo ${name} adicionado`);
          }
        }
      } else {
        const response = await api.put(
          `vehicles/manufacturers/${props.match.params.id}/models/${id}`,
          {
            name,
          },
        );

        if (response.status === 200) {
          showSuccessMessage(`Modelo ${name} atualizado`);
        }
      }
    } catch (e) {
      const responses = e.response.error;
      showErrorMessage(responses);
    }

    scrollRef.current.refresh();
  }

  function handleRender(item) {
    return <CardModels handleOpened={handleOpened} models={item} />;
  }

  function showSuccessMessage(message) {
    setSnackBar({
      display: true,
      type: 'success',
      message,
    });
  }

  function showErrorMessage(message) {
    setSnackBar({
      display: true,
      type: 'error',
      message,
    });
  }

  return (
    <>
      <Snackbar
        open={snackBar.display}
        type={snackBar.type}
        message={snackBar.message}
        onClose={() =>
          setSnackBar({
            display: false,
            type: '',
            message: '',
          })
        }
      />
      <Fab
        aria-label="Adicionar modelo"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: '1',
          border: '2px solid rgb(33, 150, 243)',
          paddingRight: '20px',
          paddingLeft: '20px',
          color: 'rgb(255, 255, 255)',
          height: '36px',
          cursor: 'pointer',
          borderRadius: '18px',
        }}
        onClick={() => {
          setName('');
          setId(null);
          toogleRef.current.toggle();
        }}
      >
        Adicionar modelo
      </Fab>
      <Typography
        variant="body2"
        gutterBottom
        style={{ textTransform: 'uppercase', marginLeft: 5 }}
      >
        {manufacturer}
      </Typography>
      <InfiniteScroll
        ref={scrollRef}
        endpoint={`vehicles/manufacturers/${props.match.params.id}/models`}
        initialFetch
        placeholderHeight={145}
        renderItem={handleRender}
        endMessage={
          <Grid container item xs={12} justify="center" style={{ marginTop: '20px' }}>
            <InfoMessage
              icon="doneall"
              width="auto"
              snackColor="#8c8c8c"
              message="Não há mais itens a serem exibidos."
            />
          </Grid>
        }
        service={api}
      />
      <Sidebar
        ref={toogleRef}
        closeButton
        iconInit={false}
        title={id ? 'Editar Modelo' : 'Novo modelo'}
        titleColor="#2d3b47"
      >
        <form onSubmit={handleSubmit} style={{ color: '#2d3b47' }}>
          <Input
            label="Nome do modelo"
            value={name}
            labelColor="#3f4f5f"
            textColor="#273748"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <div
            style={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '15px',
            }}
          >
            <Button type="submit">{id ? 'Salvar' : 'Adicionar'}</Button>
          </div>
        </form>
      </Sidebar>
    </>
  );
}
